(function () {
  // Snippet har card ke saath ye script dobara likhta hai, is liye sirf 1 baar chalao
  if (window.__ccCardLoaded) return;
  window.__ccCardLoaded = true;

  var AUTOPLAY_MS = 1800; // hover par images is speed se badlengi
  var EXPAND_DELAY_MS = 1000;

  /* ---------- Cart helpers ---------- */

  function updateCartIcon(itemCount) {
    var cartIcon = document.querySelector('cart-icon');
    var bubble = document.querySelector('.cart-bubble');
    var bubbleText = document.querySelector('.cart-bubble__text-count');
    var liveRegion = document.querySelector('[data-testid="cart-count-live-region"]');

    if (bubbleText) {
      bubbleText.textContent = itemCount;
      bubbleText.classList.toggle('hidden', itemCount === 0);
    }
    if (bubble) {
      bubble.classList.toggle('visually-hidden', itemCount === 0);
    }
    if (cartIcon) {
      cartIcon.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
    }
    if (liveRegion) {
      liveRegion.textContent = itemCount + ' items in cart';
    }
  }

  function drawerHasRows() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return true; // drawer hi nahi hai to heal ki zaroorat nahi
    return !!drawer.querySelector('.cart-items__table-row[data-key]');
  }

  /* Khali cart par home page par drawer ki CSS files load hi nahi hotin (theme unhein sirf tab
     laata hai jab cart mein items hon). Is liye swap se pehle fetched page ki stylesheets
     (<link> aur <style>) jo abhi current page mein nahi hain, unhein inject karo aur load hone do. */
  function ensureStyles(doc) {
    var waits = [];

    doc.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      var exists = Array.prototype.some.call(
        document.querySelectorAll('link[rel="stylesheet"]'),
        function (l) { return l.getAttribute('href') === href; }
      );
      if (exists) return;

      var el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = href;
      if (link.media) el.media = link.media;
      waits.push(new Promise(function (resolve) {
        el.onload = resolve;
        el.onerror = resolve;
        setTimeout(resolve, 3000); // atakna nahi chahiye
      }));
      document.head.appendChild(el);
    });

    var existingStyles = Array.prototype.map.call(
      document.querySelectorAll('style'),
      function (st) { return st.textContent; }
    );
    doc.querySelectorAll('style').forEach(function (st) {
      var text = st.textContent;
      if (!text || existingStyles.indexOf(text) !== -1) return;
      var el = document.createElement('style');
      el.textContent = text;
      document.head.appendChild(el);
      existingStyles.push(text);
    });

    return Promise.all(waits);
  }

  function swapCart(doc) {
    // 1) Cart drawer
    var freshDrawer = doc.querySelector('cart-drawer-component');
    var oldDrawer = document.querySelector('cart-drawer-component');
    if (freshDrawer && oldDrawer) {
      var oldDialog = oldDrawer.querySelector('dialog');
      var freshDialog = freshDrawer.querySelector('dialog');
      if (oldDialog && freshDialog) {
        oldDialog.innerHTML = freshDialog.innerHTML;
      } else {
        oldDrawer.innerHTML = freshDrawer.innerHTML;
      }
    }

    // 2) Cart page (agar user cart page par ho)
    var freshPage = doc.querySelector('cart-items-component:not([data-drawer])');
    var oldPage = document.querySelector('cart-items-component:not([data-drawer])');
    if (freshPage && oldPage) {
      oldPage.innerHTML = freshPage.innerHTML;
    }
  }

  /* Current page dobara fetch karke naya cart drawer / cart page markup swap karta hai.
     Dialog element wohi rehta hai, sirf andar ka content badalta hai, is liye drawer khula rehta hai. */
  function refreshCartSections() {
    return fetch(window.location.pathname + window.location.search, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html' }
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return ensureStyles(doc).then(function () { swapCart(doc); });
      })
      .catch(function (err) {
        console.warn('[cc-card] cart refresh fail hua', err);
      });
  }

  /* Add ke baad: agar drawer mein items ki rows nahi hain to drawer dobara render karo.
     Do dafa try karta hai (theme apna kaam kar chuka ho to kuch nahi hota). */
  function ensureDrawerShowsCart(itemCount) {
    if (!itemCount) return;

    setTimeout(function () {
      if (drawerHasRows()) return;
      refreshCartSections().then(function () {
        setTimeout(function () {
          if (!drawerHasRows()) refreshCartSections();
        }, 1200);
      });
    }, 900);
  }

  /* Cart ko server ke saath sync karo: bubble ka number aur drawer ki rows.
     Zaroorat isliye hai ke Back/Forward (bfcache) ya theme ki prefetch cache purana HTML dikha deti hai
     (jaise bubble mein 2, jab cart mein asal mein 3 ho). */
  var syncing = false;
  function syncCart() {
    if (syncing) return;
    syncing = true;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartIcon(cart.item_count);

        var drawer = document.querySelector('cart-drawer-component');
        if (drawer) {
          var rows = drawer.querySelectorAll('.cart-items__table-row[data-key]').length;
          if (rows !== cart.items.length) return refreshCartSections();
        }
      })
      .catch(function (err) {
        console.warn('[cc-card] cart sync fail hua', err);
      })
      .then(function () { syncing = false; });
  }

  function openDrawerIfClosed() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var dialog = drawer.querySelector('dialog');
    if (dialog && dialog.open) return;
    if (typeof drawer.open === 'function') {
      try { drawer.open(); } catch (e) {}
    }
  }

  function flashButton(btn, text, className) {
    if (!btn) return;
    var originalText = btn.dataset.ccLabel || btn.textContent;
    btn.dataset.ccLabel = originalText;
    if (className) btn.classList.add(className);
    btn.textContent = text;
    setTimeout(function () {
      if (className) btn.classList.remove(className);
      btn.textContent = originalText;
    }, 1500);
  }

  /* Theme ki apni "cart lines update" event (drawer kholne aur bubble update ke liye).
     Agar load na ho to null milta hai aur hamara apna refresh chalta hai. */
  function loadCartEventClass() {
    return import('@shopify/events')
      .then(function (mod) { return mod.CartLinesUpdateEvent || null; })
      .catch(function () { return null; });
  }

  function addToCart(variantId, triggerBtn) {
    if (!variantId) return;

    var payload = { id: variantId, quantity: 1 };

    loadCartEventClass()
      .then(function (CartEvent) {
        var deferred = null;

        if (CartEvent) {
          deferred = CartEvent.createPromise();
          (triggerBtn || document).dispatchEvent(
            new CartEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: deferred.promise
            })
          );
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (res) { return res.json(); })
          .then(function (added) {
            if (added.status) throw new Error(added.description || added.message || 'Add failed');

            return fetch('/cart.js')
              .then(function (res) { return res.json(); })
              .then(function (cart) {
                updateCartIcon(cart.item_count);

                if (deferred) {
                  deferred.resolve({
                    cart: CartEvent.createCartFromAjaxResponse(cart),
                    detail: {
                      items: cart.items,
                      source: 'cc-card',
                      sourceId: 'cc-card',
                      itemCount: 1,
                      productId: String(added.product_id),
                      sections: added.sections,
                      didError: false
                    }
                  });
                } else {
                  refreshCartSections().then(openDrawerIfClosed);
                }

                // Dono raaston mein: agar drawer khali reh jaye to dobara render
                ensureDrawerShowsCart(cart.item_count);

                flashButton(triggerBtn, 'Added', 'is-added');
              });
          })
          .catch(function (err) {
            if (deferred) deferred.reject(err);
            throw err;
          });
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        flashButton(triggerBtn, 'Unavailable', null);
      });
  }

  /* ---------- Card ---------- */

  function initCard(card) {
    if (card.dataset.ccInit) return;
    card.dataset.ccInit = 'true';

    var images = card.querySelectorAll('.cc-card__image');
    var dots = card.querySelectorAll('.cc-card__dot');
    var media = card.querySelector('.cc-card__media');
    var quickAdd = card.querySelector('.cc-card__quick-add');
    var current = 0;
    var activeCount = images.length;
    var autoplayTimer = null;
    var expandTimer = null;
    var originalSrcs = Array.prototype.map.call(images, function (img) {
      return img.getAttribute('src');
    });

    /* --- Variants data --- */
    var variants = [];
    try {
      var dataEl = card.querySelector('script[data-cc-variants]');
      if (dataEl) variants = JSON.parse(dataEl.textContent) || [];
    } catch (err) {
      variants = [];
    }

    var colorIdx = parseInt(card.dataset.colorIndex, 10);
    var qaIdx = parseInt(card.dataset.qaIndex, 10);
    if (isNaN(colorIdx)) colorIdx = -1;
    if (isNaN(qaIdx)) qaIdx = -1;

    var selectedColor = null;

    // Selected color + (optional) size ka wo variant jo sach mein maujood aur in-stock ho
    function findVariant(color, qaValue) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.a) continue;
        if (colorIdx >= 0 && color !== null && v.o[colorIdx] !== color) continue;
        if (qaIdx >= 0 && qaValue !== null && v.o[qaIdx] !== qaValue) continue;
        return v;
      }
      return null;
    }

    function colorHasStock(color) {
      return !!findVariant(color, null);
    }

    var toggleBtn = card.querySelector('[data-role="toggle"]');
    var directAddBtn = card.querySelector('[data-role="add"]');
    var variantBtns = card.querySelectorAll('.cc-card__variant-btn');
    var swatches = card.querySelectorAll('.cc-card__swatch');

    function setLabel(btn, text) {
      if (!btn) return;
      if (!btn.dataset.ccLabel) btn.dataset.ccLabel = btn.textContent.trim();
      btn.textContent = text;
    }

    // Selected color ke hisab se saare buttons ki availability update karo
    function refreshAvailability() {
      var anyAvailable = false;

      variantBtns.forEach(function (btn) {
        var v = findVariant(selectedColor, btn.dataset.value);
        btn.disabled = !v;
        btn.dataset.variantId = v ? v.id : '';
        if (v) anyAvailable = true;
      });

      if (toggleBtn) {
        toggleBtn.disabled = !anyAvailable;
        setLabel(toggleBtn, anyAvailable ? toggleBtn.dataset.ccOriginal || 'Quick add' : 'Sold out');
        if (!toggleBtn.dataset.ccOriginal) toggleBtn.dataset.ccOriginal = 'Quick add';
        if (!anyAvailable && quickAdd) quickAdd.classList.remove('is-expanded');
      }

      if (directAddBtn) {
        var dv = findVariant(selectedColor, null);
        directAddBtn.disabled = !dv;
        directAddBtn.dataset.variantId = dv ? dv.id : '';
        directAddBtn.textContent = dv ? 'Quick add' : 'Sold out';
        directAddBtn.dataset.ccLabel = directAddBtn.textContent;
      }

      swatches.forEach(function (s) {
        s.classList.toggle('is-soldout', !colorHasStock(s.dataset.color));
      });
    }

    /* --- Gallery --- */
    function show(index) {
      if (!activeCount) return;
      current = (index + activeCount) % activeCount;
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (activeCount < 2) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        show(current + 1);
      }, AUTOPLAY_MS);
    }

    /* Autoplay ab sirf hover par chalta hai (mobile par images nahi badalti) */
    if (media) {
      media.addEventListener('mouseenter', function () {
        // Hover par seedha doosri image dikhao
        if (activeCount > 1) show(1);
        if (quickAdd) {
          expandTimer = setTimeout(function () {
            if (toggleBtn && toggleBtn.disabled) return;
            quickAdd.classList.add('is-expanded');
          }, EXPAND_DELAY_MS);
        }
      });

      media.addEventListener('mouseleave', function () {
        stopAutoplay();
        show(0);
        if (expandTimer) {
          clearTimeout(expandTimer);
          expandTimer = null;
        }
        if (quickAdd) quickAdd.classList.remove('is-expanded');
      });
    }

    /* --- Quick add buttons --- */
    if (toggleBtn && quickAdd) {
      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (toggleBtn.disabled) return;
        quickAdd.classList.toggle('is-expanded');
      });
    }

    if (directAddBtn) {
      directAddBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (directAddBtn.disabled) return;
        addToCart(directAddBtn.dataset.variantId, directAddBtn);
      });
    }

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled || !btn.dataset.variantId) return;
        addToCart(btn.dataset.variantId, btn);
      });
    });

    /* --- Color / Print swatches --- */
    function applySwatch(swatch) {
      stopAutoplay();

      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');

      selectedColor = swatch.dataset.color || null;
      refreshAvailability();

      var imagesData = swatch.dataset.images || '';
      var colorImages = imagesData.split(',').filter(function (url) {
        return url.trim().length > 0;
      });

      if (colorImages.length > 1) {
        // Is color ki kam az kam 2 images mili (alt text se match)
        images.forEach(function (img, i) {
          if (i < colorImages.length) {
            img.src = colorImages[i];
            img.classList.remove('is-hidden');
          } else {
            img.classList.add('is-hidden');
          }
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-hidden', i >= colorImages.length);
        });
        activeCount = colorImages.length;
      } else if (images.length) {
        // Color ki alag images nahi mili: pehli image variant ki, baqi card ki apni images
        var firstSrc = colorImages[0] || swatch.dataset.fullImage;
        images.forEach(function (img, i) {
          img.src = i === 0 && firstSrc ? firstSrc : originalSrcs[i];
          img.classList.remove('is-hidden');
        });
        dots.forEach(function (dot) {
          dot.classList.remove('is-hidden');
        });
        activeCount = images.length;
      }

      current = 0;
      show(0);
      // Autoplay yahan start nahi hota, wo sirf hover par chalta hai
    }

    if (swatches.length) {
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          applySwatch(swatch);
        });
      });

      /* Default: pehla color jo stock mein ho (warna pehla swatch) */
      var initial = swatches[0];
      for (var i = 0; i < swatches.length; i++) {
        if (colorHasStock(swatches[i].dataset.color)) {
          initial = swatches[i];
          break;
        }
      }
      applySwatch(initial);
    } else {
      refreshAvailability();
    }
  }

  function initAll(scope) {
    var root = scope || document;
    if (root.matches && root.matches('.cc-card')) initCard(root);
    root.querySelectorAll('.cc-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  /* Har page load par, back/forward (bfcache) par, aur tab wapas khulne par cart sync karo */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCart);
  } else {
    syncCart();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) syncCart();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') syncCart();
  });

  /* Filter / sort / category tab se grid AJAX se dobara banti hai:
     nayi cards ko bhi chalu karo. */
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initAll(document);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();